query competitionById($id: UUID!) {
  competition: competitionByCompetitionId(competitionId: $id) {
    competitionId
    competitionName
    sportId
  }
}
